import {
  addUpdateMealPlanService,
  checkExistence,
  getNutrientsList,
  getPlanByDate,
} from "../services/MealPlannerService";
import { createActionThunk } from "redux-thunk-actions";
import {
  ADD_NEW_FOOD_MEAL_PLANNER,
  ADD_UPDATE_MEAL_PLANNER,
  MEAL_PLAN_PAGE_BARCODE_READ,
  MEAL_PLAN_PAGE_BARCODE_READ_IMG,
  CLEAR_MEALPLANNER_FORM,
  CLEAR_PLANNER,
  DELETE_FOOD_MEAL_PLANNER,
  GET_ITEM_DETAILS,
  getEnded,
  getFailed,
  getStarted,
  getSucceeded,
  LIST_COMBINE_MEAL_PLANNER,
  MEAL_ITEM_CLICK_MEALPALNNER,
  MEAL_PLANNER_INITIALIZATION,
  ON_CHANGE_ALERT_STATUS,
  ON_CHANGE_MEALPLANNERFORM,
  ON_SELECT_ITEM_TO_DELETE,
  PARTIAL_RESULT_FOUND,
  TOGGLE_UNSAVE_MESSAGE,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  RESET_CONTRIBUTE_ALERT_STATE,
  MEAL_PLANNER_SET_LOADING,
} from "./constant";
import moment from "moment";
import {
  barcodeService,
  getDetail,
  getPartialResult,
} from "../services/AutocompleteService";
import { getBarcode } from "../services/ContributeService";

const initialization = createActionThunk(
  MEAL_PLANNER_INITIALIZATION,
  async (date) => {
    const nutrientsList = await getNutrientsList();
    if (date) {
      let data = undefined;
      let isEditing = true;
      try {
        data = await getPlanByDate(moment(date).unix() * 1000, 1);
      } catch (e) {
        data = undefined;
        isEditing = false;
      } finally {
        return { isEditing, date, nutrientsList, data };
      }
    } else {
      return { isEditing: false, nutrientsList };
    }
  }
);
const onChangeMealPlanner = (e) => {
  return async (dispatch) => {
    if (e.target.name == "newMeal") {
      dispatch({
        type: ON_CHANGE_MEALPLANNERFORM,
        event: e,
      });
    } else if (e.target.name == "addMealPlan") {
      // let data = getDetail(e.target.value._id);
      dispatch({
        type: ON_CHANGE_MEALPLANNERFORM,
        event: e,
        data: e.target.value,
      });
    } else if (e.target.name == "changeMealCategory") {
      // let data = getDetail(e.target.value._id);
      dispatch({
        type: ON_CHANGE_MEALPLANNERFORM,
        event: e,
        data: e.target.value,
      });
    } else if (e.target.name == "time") {
      dispatch({ 
        type: MEAL_PLANNER_SET_LOADING,
        isLoading: true 
      });

      let data = undefined;
      try {
        data = await getPlanByDate(e.target.value.unix() * 1000, 1);
      } catch (e) {
        data = undefined;
      } finally {
        dispatch({
          type: ON_CHANGE_MEALPLANNERFORM,
          event: e,
          data: data,
        });

        dispatch({ 
          type: MEAL_PLANNER_SET_LOADING, 
          isLoading: false 
        });
      }
    } else {
      dispatch({
        type: ON_CHANGE_MEALPLANNERFORM,
        event: e,
      });
    }
  };
};
const mealItemOnClick = (vId) => {
  return (dispatch) => {
    dispatch({
      type: MEAL_ITEM_CLICK_MEALPALNNER,
      vId,
    });
  };
};
const addFood = (newMeal) => async (dispatch) => {
  const extra = await checkExistence(newMeal);
  dispatch({
    type: ADD_NEW_FOOD_MEAL_PLANNER,
    extra,
  });
};

const deleteItem = (vId) => (dispatch) =>
  dispatch({ type: DELETE_FOOD_MEAL_PLANNER, vId });

// const savePage = createActionThunk(
//   ADD_UPDATE_MEAL_PLANNER,
//   (time, mealListAll, planId) =>
//     addUpdateMealPlanService(time, mealListAll, planId)
// );

const savePage = (time, mealListAll, planId) => {
  return async (dispatch) => {
    dispatch({ type: getStarted(ADD_UPDATE_MEAL_PLANNER) });

    try {
      const data = await addUpdateMealPlanService(time, mealListAll, planId);

      if (data && data.message) {
        throw { message: data.message, meta: data.meta };
      }

      dispatch({
        type: getSucceeded(ADD_UPDATE_MEAL_PLANNER),
        payload: data,
      });
    } catch (e) {
      dispatch({
        type: getFailed(ADD_UPDATE_MEAL_PLANNER),
        error: {
          message: typeof e === "string" ? e : (e && e.message),
          meta: (e && e.meta) || [],
        },
      });
    } finally {
      dispatch({ type: getEnded(ADD_UPDATE_MEAL_PLANNER) });
    }
  };
};

const listCombine = (status) => (dispatch) => {
  return dispatch({ type: LIST_COMBINE_MEAL_PLANNER, status });
};
const toggleUnsaveMessage = () => ({ type: TOGGLE_UNSAVE_MESSAGE });

export const barcodeSearch = (val, cat, partial, preloadedData = null) => {
  console.log("BARCODE TYPE-IN")
  return async (dispatch) => {
    let category = cat ? cat : "02";
    //let level = "111111";

    dispatch({
      type: getStarted(MEAL_PLAN_PAGE_BARCODE_READ),
    });
    try {
      if (partial) {
        let data = preloadedData ? preloadedData : await barcodeService(val, cat);
        if (data.message) {
          //throw data.message;
          alert(data.message);
        } else {
          data = data;
        }
        // data = await getDetailService(item._id);
        //if (this.props.onSelect) this.props.onSelect(data);
        dispatch({
          type: getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ),
          data: data,
        });
        if (data.is_ref) {
          data = await getDetail(
            data._id,
            "csize",
            false,
            data.lang_id || false
          );
        }
        dispatch({
          type: ON_CHANGE_MEALPLANNERFORM,
          event: { target: { name: "addMealPlan" } },
          data: data,
        });
      } else {
        let data;
        let partialSearch = await getPartialResult(val, cat);
        if (partialSearch.length === 1 && partialSearch[0].upc === val) {
          data = await barcodeService(partialSearch[0].upc, cat);
          const needsMealDetail =
            (["02", "06"].includes(data.category) && data.is_ref) ||
            (!data.is_ref &&
              !data.is_own &&
              !data.is_history &&
              data.number_of_contribute >= 4 &&
              data.show_prompt) ||
            (!data.is_ref &&
              !data.is_own &&
              !data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt) ||
            (["02", "06"].includes(data.category) &&
              !data.is_ref &&
              data.is_own) ||
            (["02", "06"].includes(data.category) &&
              !data.is_ref &&
              !data.is_own &&
              data.is_history);
          let mealData = {};
          if (data.message) {
            //throw data.message;
            alert(data.message);
          } else {
            mealData = data;
            if (needsMealDetail && data.is_ref) {
              mealData = await getDetail(
                data._id,
                "csize",
                false,
                data.lang_id || false
              );
            }
          }
          dispatch({
            type: getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ),
            data: data,
            partialSearch,
          });
          if (needsMealDetail) {
            dispatch({
              type: ON_CHANGE_MEALPLANNERFORM,
              event: { target: { name: "addMealPlan" } },
              data: mealData,
            });
          }
        } else {
          if (partialSearch.length === 0) {
            dispatch({
              type: getFailed(PARTIAL_RESULT_FOUND),
              upc: val,
            });
          } else {
            dispatch({
              type: getSucceeded(PARTIAL_RESULT_FOUND),
              partialSearch,
            });
          }
        }
      }
    } catch (e) {
      dispatch({
        type: getFailed(MEAL_PLAN_PAGE_BARCODE_READ),
        upc: val,
      });
      // alert("Item not found");
    }
    dispatch({
      type: getEnded(MEAL_PLAN_PAGE_BARCODE_READ),
    });
  };
};
const onSubmitUpcImage = (image, cat = "02") => {
  console.log("BARCODE UPLOAD")
  return async (dispatch) => {
    let category = cat;

    // Start the barcode image reading process
    dispatch({ type: getStarted(MEAL_PLAN_PAGE_BARCODE_READ_IMG) });

    try {
      // Fetch the barcode number from the image
      const barcodeNum = await getBarcode(image);
      dispatch({
        type: getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ_IMG),
        data: barcodeNum,
      });

      // Start the barcode reading process
      dispatch({ type: getStarted(MEAL_PLAN_PAGE_BARCODE_READ) });

      try {
        // Fetch the barcode data
        let data = await barcodeService(barcodeNum.barcode, category);
        let mealData = data;
        const needsMealDetail =
          (["02", "06"].includes(data.category) && data.is_ref) ||
          (!data.is_ref &&
            !data.is_own &&
            !data.is_history &&
            data.number_of_contribute >= 4 &&
            data.show_prompt) ||
          (!data.is_ref &&
            !data.is_own &&
            !data.is_history &&
            data.number_of_contribute >= 4 &&
            !data.show_prompt) ||
          (["02", "06"].includes(data.category) &&
            !data.is_ref &&
            data.is_own) ||
          (["02", "06"].includes(data.category) &&
            !data.is_ref &&
            !data.is_own &&
            data.is_history);

        if (data.message) {
          // Handle the case where there's an error message
          alert(data.message);
        } 
        else {
          // Check if we need to fetch additional meal details
          if (needsMealDetail && data.is_ref) {
            mealData = await getDetail(
              data._id,
              "csize",
              false,
              data.lang_id || false
            );
          }
        }

        // Dispatch barcode read success with data from barcodeService
        // dispatch({
        //   type: getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ),
        //   data: mealData, // Only data from barcodeService
        //   mealData,
        // });
        dispatch({
          type: getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ),
          data: data, // Only data from barcodeService
        });

        // let resolvedMealData = data;

        // if (needsMealDetail && data.is_ref) {
        //   resolvedMealData = await getDetail(
        //     data._id,
        //     "csize",
        //     false,
        //     data.lang_id || false
        //   );
        // }


        // If meal details were fetched, dispatch the meal planner form update
        if (needsMealDetail) {
          dispatch({
            type: ON_CHANGE_MEALPLANNERFORM,
            event: { target: { name: "addMealPlan" } },
            data: data,
          });
        }
      } catch (error) {
        // Dispatch failure for barcode read
        dispatch({
          type: getFailed(MEAL_PLAN_PAGE_BARCODE_READ),
          upc: barcodeNum.barcode,
          message: error.message && error.message === "" ? "" : false,
        });
      } finally {
        // End the barcode reading process
        dispatch({ type: getEnded(MEAL_PLAN_PAGE_BARCODE_READ) });
      }
    } catch (error) {
      // Dispatch failure for barcode image read
      dispatch({
        type: getFailed(MEAL_PLAN_PAGE_BARCODE_READ_IMG),
        error: error,
      });
    }
  };
};

const clearMealPlannerForm = () => {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_MEALPLANNER_FORM,
    });
  };
};

const getDetailsServiceAndAssign = (item) => {
  return async (dispatch) => {
    try {
      let data = await getDetail(
        item._id,
        item.category,
        this.props.noUser,
        item.lang_id || false
      );
      if (data.message) {
        //throw data.message;
        alert(data.message);
      } else {
        data = data;
      }
      dispatch({
        type: getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ),
        data: data,
      });
      dispatch({
        type: getSucceeded(GET_ITEM_DETAILS),
      });
      dispatch({
        type: getEnded(GET_ITEM_DETAILS),
      });
    } catch (error) {
      dispatch({
        type: getFailed(GET_ITEM_DETAILS),
        date: error,
      });
    }
  };
};

const onChangeAlertStatus = (item) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ON_CHANGE_ALERT_STATUS,
        data: item,
      });
    } catch (error) {}
  };
};

const setDeletingItem = (id, is_delete) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ON_SELECT_ITEM_TO_DELETE,
        is_delete: is_delete,
        id: id,
      });
    } catch (error) {}
  };
};

const clearPlanner = () => {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_PLANNER,
    });
  };
}

const addGreyUPCToItemNameField = (barcode) => ({
  type: ADD_GREY_UPC_ITEM_NAME_FIELD,
  payload: barcode,
});
const resetContributeAlertState = () => ({
  type: RESET_CONTRIBUTE_ALERT_STATE,
});


export default {
  initialization,
  onChangeMealPlanner,
  addFood,
  mealItemOnClick,
  deleteItem,
  clearPlanner,
  savePage,
  listCombine,
  toggleUnsaveMessage,
  barcodeSearch,
  onSubmitUpcImage,
  clearMealPlannerForm,
  getDetailsServiceAndAssign,
  onChangeAlertStatus,
  setDeletingItem,
  addGreyUPCToItemNameField,
  resetContributeAlertState,
};



// WEBPACK FOOTER //
// ./src/actions/mealPlannerActions.js